/*
 * @Description:
 * @Date: 2020-07-18 16:13:15
 */

import { BI } from '@/api/ajax';
import combination from './combination';
import { percentage } from '@/tools/index';
import {
  createBarSeries,
  createBarCircleSeries,
  createLineSeries,
  createMapSeries
} from '../components/Echarts/echartOption';
import { axisFormatter, dealProvince, dealTips } from '../tools/index';

export default {
  query: {},
  // 上部分
  ...combination,
  querytaskHospitalDistribution() {
    return new Promise(async (resolve, reject) => {
      let {
        data: {
          data: { datas, dataCount }
        }
      } = await BI[this.query.serviceType].querytaskHospitalDistribution(
        this.query
      );
      datas = datas || [];
      let header = [
        { label: '地名', prop: 'd' },
        { label: '医院数量（所）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      const { data, series0data } = dealProvince(datas, dataCount);
      resolve({
        key: 'querytaskHospitalDistribution',
        value: {
          header: {
            index: 1,
            title: '拜访医院分布',
            name: '拜访医院分布'
          },
          table: {
            header: header.map(item => {
              item['width'] = Math.max(`${item.label}`.length * 20, 100);
              return item;
            }),
            data,
            finalDataCount: dataCount,
            isNormal: true
          },
          useMapLayout: true,
          echart: [
            {
              echartType: 'map',
              echartStyle: { width: '630px', height: '450px' },
              echartOption: {
                series: createMapSeries(series0data, dataCount)
              }
            }
          ]
        }
      });
    });
  },
  // querytaskImgs() {
  //   return new Promise(async (resolve, reject) => {
  //     let { data } = await BI[this.query.serviceType].querytaskImgs(this.query);
  //     let resp = data.data || [];
  //     let images = resp.map(item => item.imgUrl);
  //     resolve({
  //       key: 'querytaskImgs',
  //       value: {
  //         header: {
  //           index: 2,
  //           title: '拜访医院照片墙',
  //           name: '拜访医院照片墙'
  //         },
  //         images
  //       }
  //     });
  //   });
  // },
  // 医院等级分布
  querytaskHospitalGradeDistribution() {
    return new Promise(async (resolve, reject) => {
      let {
        data: {
          data: { dataCount, projectId, taskDt, ...grades }
        }
      } = await BI[this.query.serviceType].querytaskHospitalGradeDistribution(
        this.query
      );
      let header = [
        { label: '医院等级', prop: 'd' },
        { label: '医院数量（所）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let map = {
        gradeName_3_t: {
          name: '三级特等',
          value: ''
        },
        gradeName_3_j: {
          name: '三级甲等',
          value: ''
        },
        gradeName_3_y: {
          name: '三级乙等',
          value: ''
        },
        gradeName_3_b: {
          name: '三级丙等',
          value: ''
        },
        gradeName_2_j: {
          name: '二级甲等',
          value: ''
        },
        gradeName_2_y: {
          name: '二级乙等',
          value: ''
        },
        gradeName_2_b: {
          name: '二级丙等',
          value: ''
        }
      };
      let data = [];
      let xAxisData = [];
      let series0data = [];
      Object.entries(grades).forEach(item => {
        map[item[0]].value = item[1];
      });
      Object.values(map).forEach(item => {
        xAxisData.push(item.name);
        series0data.push(item.value);
        data.push({
          d: item.name,
          v: item.value,
          b: percentage(item.value, dataCount)
        });
      });
      resolve({
        key: 'queryVisitMinuteInfo',
        value: {
          header: {
            index: 2,
            title: '医院等级分布',
            name: '医院等级分布'
          },
          table: { header, data, finalDataCount: dataCount },
          echart: [
            {
              echartType: 'line',
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '所');
                  }
                },
                xAxis: {
                  type: 'category',
                  data: xAxisData
                },
                yAxis: {
                  name: '医院数量（所）'
                },
                series: createLineSeries(series0data)
              }
            }
          ]
        }
      });
    });
  },
  querytaskDepartmentDistribution() {
    return new Promise(async (resolve, reject) => {
      let {
        data: {
          data: { datas, dataCount }
        } // data: { data:{datas,dataCount} } 结构总是便！
      } = await BI[this.query.serviceType].querytaskDepartmentDistribution(
        this.query
      );
      datas = datas || [];
      // let dataCount = data.reduce((p,c) =>p+Number(c.cc) ,0)
      let header = [
        { label: '科室', prop: 'd' },
        { label: '科室数量（个）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let tableData = [];
      let xAxisData = [];
      let series0data = [];
      datas.forEach(item => {
        xAxisData.push(item.departmentName);
        series0data.push(item.cc);
        tableData.push({
          d: item.departmentName,
          v: item.cc,
          b: percentage(item.cc, dataCount)
        });
      });
      resolve({
        key: 'querytaskDepartmentDistribution',
        value: {
          header: {
            index: 3,
            title: '科室分布',
            name: '科室分布'
          },
          table: { header, data: tableData, finalDataCount: dataCount },
          echart: [
            {
              echartType: 'bar',
              echartStyle: { height: '500px' },
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '个');
                  }
                },
                xAxis: {
                  name: '科室数量（个）',
                  nameTextStyle: {
                    color: '#E0E0E0',
                    padding: [30, 0, 0, -5]
                  }
                },
                yAxis: {
                  name: '科室名称',
                  data: xAxisData
                },
                series: createBarSeries(series0data)
              }
            }
          ]
        }
      });
    });
  },
  querytaskHospitalTitleDistribution() {
    return new Promise(async (resolve, reject) => {
      let {
        data: { data }
      } = await BI[this.query.serviceType].querytaskHospitalTitleDistribution(
        this.query
      );
      data = data || { dataCount: 0, projectId: 1, taskDt: 0, dutyName1: 0 };
      let { dataCount, projectId, taskDt, ...grades } = data;
      let header = [
        { label: '医院职称', prop: 'd' },
        { label: '数量（人）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      let map = {
        dutyName1: '主任医师',
        dutyName2: '副主任医师',
        dutyName3: '主治医师',
        dutyName4: '住院/实习医师',
        dutyName5: '护士长',
        dutyName6: '护士',
        dutyName7: '药剂师',
        dutyName8: '主任技师',
        dutyName9: '住院医师',
        dutyName151: '中国科学院院士',
        dutyName155: '主管技师',
        dutyName156: '博士'
      };
      let rdata = [];
      let xAxisData = [];
      let series0data = [];
      Object.entries(grades).forEach(item => {
        xAxisData.push(map[item[0]]);
        series0data.push(item[1]);
        rdata.push({
          d: map[item[0]],
          v: item[1],
          b: percentage(item[1], dataCount)
        });
      });
      resolve({
        key: 'querytaskHospitalTitleDistribution',
        value: {
          header: {
            index: 4,
            title: '医院职称',
            name: '医院职称'
          },
          table: { header, data: rdata, finalDataCount: dataCount },
          echart: [
            {
              echartType: 'bar3',
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '人');
                  }
                },
                xAxis: {
                  data: xAxisData,
                  axisLabel: {
                    interval: 0,
                    textStyle: {
                      color: '#666',
                      fontSize: 11,
                      lineHeight: 18
                    },
                    formatter: function(params) {
                      return axisFormatter(params, xAxisData.length);
                    }
                  }
                },
                yAxis: {
                  name: '任务数（单）'
                },
                series: createBarCircleSeries(series0data, true)
              }
            }
          ]
        }
      });
    });
  },
  // 拜访时间
  querytaskVisitingTime() {
    return new Promise(async (resolve, reject) => {
      let {
        data: {
          data: { visitingTimeDay }
        }
      } = await BI[this.query.serviceType].querytaskVisitingTime(this.query);
      let visitingTimeDayXAxisData = [];
      let visitingTimeDaySeries0data = [];
      visitingTimeDay.forEach((item, index) => {
        visitingTimeDayXAxisData[index] = [];
        visitingTimeDaySeries0data[index] = [];
        let [m] = Object.entries(item);
        let days = Object.entries(m[1]);
        days.forEach(i => {
          visitingTimeDayXAxisData[index].push(i[0]);
          visitingTimeDaySeries0data[index].push(i[1]);
        });
      });
      resolve({
        key: 'querytaskVisitingTime',
        value: {
          header: {
            index: 5,
            title: '拜访时间',
            name: '拜访时间'
          },
          echart: [
            {
              echartType: 'line1',
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '单');
                  }
                },
                xAxis: {
                  type: 'category',
                  axisLabel: {
                    interval: 0,
                    textStyle: {
                      color: '#666',
                      fontSize: 12
                    }
                  },
                  data: visitingTimeDayXAxisData[0]
                },
                yAxis: {
                  name: '任务数（单）'
                },
                series0data: visitingTimeDaySeries0data
                // series: createLineSeries(visitingTimeDaySeries0data)
              }
            }
          ]
        }
      });
    });
  },
  // 每日时间分布
  querytaskVisitingTime1() {
    return new Promise(async (resolve, reject) => {
      let {
        data: {
          data: { visitingTimeHour }
        }
      } = await BI[this.query.serviceType].querytaskVisitingTime(this.query);

      let visitingTimeHourXAxisData = [];
      let visitingTimeHourSeries0data = [];
      let tableData = [];
      let dataCount = visitingTimeHour.reduce((pre, cur) => {
        let [m] = Object.entries(cur);
        pre += m[1];
        return pre;
      }, 0);
      visitingTimeHour.forEach(item => {
        let [m] = Object.entries(item);
        visitingTimeHourXAxisData.push(m[0]);
        visitingTimeHourSeries0data.push(m[1]);
        tableData.push({
          d: m[0],
          v: m[1],
          b: percentage(m[1], dataCount)
        });
      });
      resolve({
        key: 'querytaskVisitingTime1',
        value: {
          header: {
            hideHeader: true,
            title: '每日时间分布',
            name: '每日时间分布'
          },
          table: {
            header: [
              { label: '时间段', prop: 'd' },
              { label: '任务数（单）', prop: 'v' },
              { label: '百分比(%)', prop: 'b' }
            ],
            data: tableData,
            finalDataCount: dataCount
          },
          echart: [
            {
              echartType: 'bar2',
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '单');
                  }
                },
                xAxis: {
                  type: 'category',
                  data: visitingTimeHourXAxisData,
                  axisLabel: {
                    interval: 0,
                    textStyle: {
                      color: '#666',
                      fontSize: 12
                    }
                  }
                },
                yAxis: {
                  name: '任务数（单）'
                },
                series: createBarSeries(visitingTimeHourSeries0data, true)
              }
            }
          ]
        }
      });
    });
  },
  querytaskLengthVisit() {
    return new Promise(async (resolve, reject) => {
      let {
        data: {
          data: { datas }
        }
      } = await BI[this.query.serviceType].querytaskLengthVisit(this.query);
      let header = [
        { label: '分钟数', prop: 'd' },
        { label: '医院数量（所）', prop: 'v' },
        { label: '百分比(%)', prop: 'b' }
      ];
      datas = datas || [];
      let data = [];

      let xAxisData = [];
      let series0data = [];
      let finalDataCount = 0;
      let formatData = {};
      // for (let i = 0; i < 21; i++) {
      //   if (!(i % 2) && i) {
      //     xAxisData.push(i + i === 20 ? '以上' : 'min');
      //     formatData[i] = 0;
      //   }
      // }
      datas.forEach(item => {
        finalDataCount += 1;
        if (formatData[item.visitMinute]) {
          formatData[item.visitMinute] += 1;
        } else {
          if (+item.visitMinute >= 20) {
            if (!formatData['20']) {
              formatData['20'] = 1;
            } else {
              formatData['20'] += 1;
            }
          } else {
            formatData[item.visitMinute] = 1;
          }
        }
      });
      Object.entries(formatData).forEach(item => {
        xAxisData.push(item[0] >= 20 ? '20min+' : item[0] + 'min');
        series0data.push(
          Number(percentage(item[1], finalDataCount, { symbol: '' }))
        );
        data.push({
          d: item[0] >= 20 ? '20min+' : item[0] + 'min',
          v: +item[1],
          b: percentage(item[1], finalDataCount)
        });
      });
      resolve({
        key: 'querytaskLengthVisit',
        value: {
          header: {
            index: 6,
            title: '拜访时长',
            name: '拜访时长'
          },
          table: { header, data, finalDataCount },
          echart: [
            {
              echartType: 'line',
              echartOption: {
                tooltip: {
                  formatter: function(params) {
                    const { axisValue, value } = params[0] || params || {};
                    return dealTips(axisValue, value, '所');
                  }
                },
                xAxis: {
                  type: 'category',
                  data: xAxisData
                },
                yAxis: {
                  name: '医院数量（所）',
                  max: 100, //设置最大值
                  min: 0,
                  axisLabel: {
                    show: true,
                    interval: 'auto',
                    formatter(v) {
                      return `${v}%`;
                    }
                  }
                },
                series: createLineSeries(series0data)
              }
            }
          ]
        }
      });
    });
  },
  async run(query) {
    this.query = query;
    let arr = [];
    for (let i in this) {
      if (
        this.hasOwnProperty(i) &&
        i !== 'run' &&
        typeof this[i] === 'function'
      ) {
        arr.push(this[i]());
      }
    }
    return new Promise((resolve, reject) => {
      Promise.all(arr)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};
